module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE1MSIgdmlld0JveD0iMCAwIDMwMSAxNTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjQzEwMDAwIiBkPSJNLjUuNWgzMDB2MTUwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uNS41aDEyNXY3NUguNXoiLz48cGF0aCBmaWxsPSIjQzEwMDAwIiBkPSJNNTMuNjI1IDkuODc1aDE4Ljc1djU2LjI1aC0xOC43NXoiLz48cGF0aCBmaWxsPSIjQzEwMDAwIiBkPSJNMzQuODc1IDI4LjYyNWg1Ni4yNXYxOC43NWgtNTYuMjV6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-to.svg
// module id = L/gf
// module chunks = 2